import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, CardFooter, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import { H4, H6, Image, Btn } from '../../../../AbstractElements';
import config from '../../../../config';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2/dist/sweetalert2';

const LeaseEdit = () => {

    const tenant_concessionaire_id = localStorage.getItem("concessionaireId");
    const manageLeaseDetails = localStorage.getItem("manageLeaseDetails");

    if (manageLeaseDetails === "0") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }


    const login_id = localStorage.getItem("loginId");
    const { register, formState: { errors } } = useForm();
    const [tenant, setTenant] = useState({});
    const [concessionaire_name, setConcessionaireName] = useState('');
    const [country_name, setCountryName] = useState('');
    const [property_name, setPropertyName] = useState('');
    const [property_mall_code, setPropertyMallCode] = useState('');
    const [category_name, setCategoryName] = useState('');
    const [subcategory_name, setSubcategoryName] = useState('');
    const [tenant_lease_startdate, setLeaseStartDate] = useState('');
    const [tenant_lease_enddate, setLeaseEndDate] = useState('');
    const [oldlease_enddate, setOldLeaseEndDate] = useState('');
    const [tenant_base_rent, setBaseRent] = useState('');
    const [tenant_revenue_share, setRevenueShare] = useState('');
    const [revenueShareMethods, setRevenueShareMethods] = useState([]);
    const [tenant_revenue_share_method_id, setRevenueMethod] = useState('');
    const { id } = useParams();
    const navigate = useNavigate();
    const [charges, setCharges] = useState([]);
    const [charge1, setCharge1] = useState('');
    const [charge2, setCharge2] = useState('');
    const [charge3, setCharge3] = useState('');
    const [charge4, setCharge4] = useState('');
    const [charge5, setCharge5] = useState('');
    const [startDateValidationMessage, setStartDateValidationMessage] = useState('');
    const [endDateValidationMessage, setEndDateValidationMessage] = useState('');

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    const handleRevenueMethodChange = (e) => {
        setRevenueMethod(e.target.value);
    }

    const handleChargeChange = (chargeName, value) => {
        if (chargeName === 'charge1') {
            setCharge1(value)
        }
        else if (chargeName === 'charge2') {
            setCharge2(value)
        }
        else if (chargeName === 'charge3') {
            setCharge3(value)
        }
        else if (chargeName === 'charge4') {
            setCharge4(value)
        }
        else if (chargeName === 'charge5') {
            setCharge5(value)
        }
    };

    useEffect(() => {
        axios
            .post(`${config.hostname}/concessionairecharges/getcharges`, { concessionaire_id: tenant_concessionaire_id }, configheader)
            .then((response) => {
                const transformedData = response.data.map(item => ({
                    other_charge_id: item.other_charge_id._id,
                    display_name: item.display_name,
                    charge_value: item.charge_value,
                    charge_name: item.other_charge_id.charge_name
                }));
                setCharges(transformedData);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/concessionairerevenuemethods/getmethods`, { concessionaire_id: tenant_concessionaire_id }, configheader)
            .then((response) => {
                setRevenueShareMethods(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios.get(`${config.hostname}/tenant/${id}`, configheader)
            .then((response) => {
                setTenant(response.data);
                const concessionaireName = response.data.tenant_concessionaire_id.concessionaire_name;
                setConcessionaireName(concessionaireName);
                const CountryName = response.data.tenant_country_id.country_name;
                setCountryName(CountryName);
                const propertyName = response.data.tenant_property_id.property_name;
                setPropertyName(propertyName);
                const propertyMallCode = response.data.tenant_property_id.property_mall_code;
                setPropertyMallCode(propertyMallCode);
                const categoryName = response.data.tenant_category_id.category_name;
                setCategoryName(categoryName);
                const subcategoryName = response.data.tenant_subcategory_id.subcategory_name;
                setSubcategoryName(subcategoryName);
                const revenueMethod = response.data.tenant_revenue_share_method_id.revenue_method_name;
                setRevenueMethod(revenueMethod);
                const leaseStartDate = new Date(response.data.tenant_lease_startdate).toISOString().split('T')[0];
                setLeaseStartDate(leaseStartDate);
                const leaseEndDate = new Date(response.data.tenant_lease_enddate).toISOString().split('T')[0];
                setLeaseEndDate(leaseEndDate);
                setOldLeaseEndDate(leaseEndDate);
                setBaseRent(response.data.tenant_base_rent);
                setRevenueShare(response.data.tenant_revenue_share);
                setRevenueMethod(response.data.tenant_revenue_share_method_id._id);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        //Validation for start month and end month
        if (tenant_lease_enddate < tenant_lease_startdate) {
            setEndDateValidationMessage('The end date cannot be less than the start date');
            return;
        } else {
            setEndDateValidationMessage('');
        }

        if (tenant_lease_startdate < oldlease_enddate) {
            setStartDateValidationMessage("The lease start date cannot be earlier than the previous lease's end date");
            return;
        } else {
            setStartDateValidationMessage('');
        }

        SweetAlert.fire({
            title: 'Proceed with lease update?',
            text: 'Are you sure you want to update the lease details?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Update',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                const leaseData = {
                    tenant_lease_startdate,
                    tenant_lease_enddate,
                    tenant_base_rent,
                    tenant_revenue_share,
                    tenant_revenue_share_method_id,
                    tenant_charge1: charge1 || 0,
                    tenant_charge2: charge2 || 0,
                    tenant_charge3: charge3 || 0,
                    tenant_charge4: charge4 || 0,
                    tenant_charge5: charge5 || 0,
                    login_id
                };
                console.log(leaseData);
                axios
                    .post(`${config.hostname}/tenant/updatetenantlease/${id}`, leaseData, configheader)
                    .then(() => {
                        toast.success("Lease details updated successfully");
                        navigate(`${process.env.PUBLIC_URL}/admin/tenant/tenantdetail/${id}`);
                    })
                    .catch((error) => {
                        toast.error("Error updating lease details");
                        console.log(error);
                    });
            } else {
                console.log("Lease update cancelled");
            }
        });
    };

    return (
        <Row>
            <Col xl='4'>
                <Fragment>
                    <Card>
                        <CardHeader>
                            <H4 attrH4={{ className: 'card-title mb-0' }}>{tenant.tenant_store_name}</H4>
                            <div className='card-options'>
                                <a className='card-options-collapse' href='#javascript'>
                                    <i className='fe fe-chevron-up'></i>
                                </a>
                                <a className='card-options-remove' href='#javascript'>
                                    <i className='fe fe-x'></i>
                                </a>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Form>
                                <Row className='mb-2'>
                                    <div className='profile-title'>
                                        <div className='media'>
                                            <Image attrImage={{ className: 'img-70 m-0 rounded-circle', alt: '', src: `${require('../../../../assets/images/img001.jpg')}` }} />

                                        </div>
                                    </div>
                                </Row>
                                <Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Brand Name</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={tenant.tenant_brand_name} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Concessionaire</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={concessionaire_name} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup> <Label className="form-label">Country</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={country_name} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Property</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={property_name} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Mall Code</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={property_mall_code} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Unit Code</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={tenant.tenant_unit_code} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Tenant Code</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={tenant.tenant_code} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Category</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={category_name} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Subcategory</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={subcategory_name} />
                                        </FormGroup>
                                    </Row>
                                    <Row >
                                        <FormGroup className="mb-3"> <Label className="form-label">Group Name</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={tenant.tenant_group_name} />
                                        </FormGroup>
                                    </Row>
                                    <Row>
                                        <FormGroup className="mb-3"> <Label className="form-label">Franchisee</Label>
                                            <Input className="form-control" type="text" disabled="true" defaultValue={tenant.tenant_franchisee ? 'Yes' : 'No'} />
                                        </FormGroup>
                                    </Row>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Fragment>
            </Col>
            <Col xl='8'>
                <Fragment>
                    <Form className="card" onSubmit={handleSubmit}>
                        <CardHeader>
                            <H4 attrH4={{ className: "card-title mb-0" }}>Lease Details</H4>
                            <div className="card-options">
                                <a className="card-options-collapse" href="#javascript">
                                    <i className="fe fe-chevron-up"></i>
                                </a>
                                <a className="card-options-remove" href="#javascript">
                                    <i className="fe fe-x"></i>
                                </a>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="6">
                                    <FormGroup className="mb-3"> <Label className="form-label">Lease Start Date</Label>
                                        <Input className="form-control" type="date" value={tenant_lease_startdate}
                                            onChange={(e) => {
                                                setLeaseStartDate(e.target.value);
                                                if (new Date(e.target.value) > new Date(tenant_lease_enddate)) {
                                                    setLeaseEndDate(e.target.value); // Set the lease end date to match the start date if needed
                                                }
                                            }} />
                                    </FormGroup>
                                    {startDateValidationMessage && (
                                        <span className="text-danger mb-2">{startDateValidationMessage}</span>
                                    )}
                                </Col>
                                <Col md="6">
                                    <FormGroup className="mb-3"> <Label className="form-label">Lease End Date</Label>
                                        <Input className="form-control" type="date" value={tenant_lease_enddate}
                                            onChange={(e) => setLeaseEndDate(e.target.value)} />
                                    </FormGroup>
                                    {endDateValidationMessage && (
                                        <span className="text-danger mb-2">{endDateValidationMessage}</span>
                                    )}
                                </Col>

                                <Col md="6">
                                    <FormGroup className="mb-3"> <Label className="form-label">Base Rent</Label>
                                        <Input className="form-control" type="number" step="0.001" value={tenant_base_rent}
                                            placeholder='Base Rent' onChange={(e) => setBaseRent(e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="mb-3"> <Label className="form-label">Revenue Share%</Label>
                                        <Input className="form-control" type="number" step="0.001" value={tenant_revenue_share}
                                            placeholder='Revenue Share' onChange={(e) => setRevenueShare(e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col md='6'>
                                    <FormGroup className="mb-3"> <Label className="form-label">Revenue Share Method</Label>
                                        <select name="revenuemethod" id="revenuemethod" className="form-control digits" required
                                            value={tenant_revenue_share_method_id} onChange={handleRevenueMethodChange}>
                                            <option value="">Select Revenue Share Method</option>
                                            {revenueShareMethods.map(method => (
                                                <option key={method.revenue_method_id._id} value={method.revenue_method_id._id}>{method.revenue_method_id.description}</option>
                                            ))}
                                        </select>
                                    </FormGroup>
                                </Col>

                                {charges.map((charge) => (
                                    <Col md="6" key={charge.other_charge_id}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor={`charge_${charge.display_name}`}>{charge.display_name}</Label>
                                            <input
                                                className={`form-control ${errors[`charge_${charge.display_name}`] && "is-invalid"}`}
                                                id={`charge_${charge.display_name}`}
                                                type="number"
                                                name={`charge_${charge.display_name}`}
                                                defaultValue={
                                                    charge.charge_name === 'charge1' ? tenant.tenant_charge1 :
                                                        charge.charge_name === 'charge2' ? tenant.tenant_charge2 :
                                                            charge.charge_name === 'charge3' ? tenant.tenant_charge3 :
                                                                charge.charge_name === 'charge4' ? tenant.tenant_charge4 :
                                                                    charge.charge_name === 'charge5' ? tenant.tenant_charge5 :
                                                                        ''
                                                }
                                                {...register(`charge_${charge.display_name}`, {
                                                    required: true,
                                                    onChange: (e) => {
                                                        handleChargeChange(charge.charge_name, e.target.value);
                                                    },
                                                })}
                                            />
                                            <span className="text-danger">
                                                {errors[`charge_${charge.display_name}`] && `${charge.display_name} is required`}
                                            </span>
                                        </FormGroup>
                                    </Col>
                                ))}
                            </Row>
                        </CardBody>
                        <CardFooter className="text-end">
                            <Btn attrBtn={{ color: "primary", type: "submit" }}  >Update</Btn>
                        </CardFooter>
                    </Form>

                </Fragment>
            </Col>
        </Row>
    )
}

export default LeaseEdit